// extracted by mini-css-extract-plugin
export default {"headerWrapper":"header_headerWrapper__3uGrE","headerStyle":"header_headerStyle__Ci35l","pStyle":"header_pStyle__boKkV"};